export const version = '2.90.0' // bump-client-version 2026-08-04T21:09:08.094Z
